<template>
  <div class="timeline-tracks">
    <div v-for="track in tracks" :key="track.key" class="track">
      <div class="track-label"><span class="track-emoji">{{ track.emoji }}</span>{{ track.label }}</div>
      <div class="track-items">
        <div v-for="(item, i) in track.items" :key="i" class="track-item">
          <div class="dot" />
          <div class="stage">{{ item.stage }}</div>
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 三轨时间线：tracks = [{key, label, emoji, items: [{stage, content}]}]
export default {
  name: 'TimelineTrack',
  props: {
    tracks: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.timeline-tracks { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 14px; margin-top: 12px; }
.track { background: var(--bg-2); border: 1px solid var(--border-2); border-radius: var(--radius); padding: 14px; }
.track-label { font-weight: 600; font-size: 13px; margin-bottom: 12px; color: var(--text-1); }
.track-emoji { margin-right: 6px; }
.track-item { position: relative; padding: 0 0 16px 18px; border-left: 2px solid var(--border-1); }
.track-item:last-child { padding-bottom: 0; border-left-color: transparent; }
.dot { position: absolute; left: -5px; top: 2px; width: 8px; height: 8px; border-radius: 50%; background: var(--primary-2); box-shadow: 0 0 0 3px var(--primary-a15); }
.stage { font-size: 12px; color: var(--accent); font-weight: 600; }
.content { font-size: 12px; color: var(--text-2); line-height: 1.7; margin-top: 3px; }
</style>
